import { render, staticRenderFns } from "./LoaderScreen.vue?vue&type=template&id=0fafac6b&scoped=true"
import script from "./LoaderScreen.vue?vue&type=script&lang=js"
export * from "./LoaderScreen.vue?vue&type=script&lang=js"
import style0 from "./LoaderScreen.vue?vue&type=style&index=0&id=0fafac6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fafac6b",
  null
  
)

export default component.exports